<template>
    <div  v-if="viewQuestion">
   
        <v-row  justify="end">

            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                <v-select label="Plantilla" v-model="json_contenido.plantilla" @change="eventPlantilla(json_contenido.plantilla)"
                    :items="Plantillas" item-value="id" item-text="nombre_template">
                </v-select>
            </v-col>
            <v-btn  class="btn_block_style2 mr-2" dark  @click="Templates()">Ver Plantillas</v-btn>
            <v-btn  class="btn_block_style2 mr-2" dark  @click="visorDiapositivas(dataSet)">Ver Diapositivas</v-btn>
            <v-btn class="btn_style3 mr-4" dark  @click="$emit('close')">Volver</v-btn>
        </v-row>

        <!-- ini -->
        <v-alert type="info" outlined border="left"><h3>Múltiples respuestas</h3></v-alert>
        

                <!-- load edit events  -->
        <v-row v-if="gestorBackground" class="mx-2" :style="[{'background-color':color_fondo}]">
            <v-col cols="12" class="contenedor_texto mt-2">               
                <v-col class="d-flex justify-space-between titulo-text mb-4">
                    <h4>Fondo</h4>
                    <v-btn fab dark x-small class="btn_style3" @click="gestorBackground=false"><v-icon dark>fa-times</v-icon></v-btn>
                </v-col>

                <v-color-picker v-model="color_fondo"></v-color-picker>
            </v-col>

            <v-row justify="end"> 
                <v-btn class="btn_block_style2 mr-4" dark  @click="saveBackground(tag); gestorBackground=false">Agregar</v-btn>
            </v-row>
        </v-row>

            
        <v-row v-if="gestionEditor" class="mx-2" :style="[{'background-color':color_fondo}]">
            <v-col cols="12" class="contenedor_texto mt-2">                       
                <v-col class="d-flex justify-space-between titulo-text mb-4">
                    <h4>{{tipoOperacion}}</h4>
                    <v-btn fab dark x-small class="btn_style3" @click="gestionEditor=false"><v-icon dark>fa-times</v-icon></v-btn>                    
                </v-col>

                <ckeditor v-model="editorData" :config="editorConfig"></ckeditor>
            </v-col>

            <v-row justify="end">
                <v-btn v-if="evento=='agregar'" class="btn_block_style2" dark  @click="saveText(tag)">Agregar</v-btn>
                <!--
                <v-btn v-if="evento=='editar'" class="btn_block_style2" dark  @click="doneEditText(indexTarea)">Editar</v-btn>
                -->
            </v-row>
        </v-row>
            
                 

        <v-row v-if="gestionRespuesta">
            
            <v-col cols="10">
                <v-textarea v-model="nuevaTarea" label="Agregar opción" @keyup.enter="agregarTarea" outlined ></v-textarea>
            </v-col>
            <v-col cols>
                <v-btn @click="agregarTarea" class="primary">Agregar <v-icon class="ml-1">fa-plus-circle</v-icon></v-btn> 
            </v-col> 
                
        </v-row>

        
        <!-- <v-btn class="ma-2" @click="agregarTarea" color="primary" dark>Agregar <v-icon dark right>fas fa-plus-square</v-icon>  </v-btn> -->
        <div class="grey lighten-3 pl-3 pt-3 pr-3 mt-3">
            <v-row>
                <v-col cols="12">
                    <v-card outlined class="text-center mb-3" :style="[{'background-color':json_contenido.color_fondo_titulo}]">
                        <div v-html="json_contenido.titulo"></div>
                    
                        <v-btn class="btn_editar mr-2" fab x-small title="Editar" @click="activateElement('titulo')">
                            <v-icon small>fa-pencil-alt</v-icon>
                        </v-btn>

                        <v-btn class="btn_palette mr-2" fab x-small title="Editar Color de Fondo" @click="activateBackground('titulo')">
                            <v-icon small>fas fa-palette</v-icon>
                        </v-btn>                       
                    </v-card>

                    <v-card outlined class="text-center mb-3" :style="[{'background-color':json_contenido.color_fondo_pregunta}]">
                        <div v-html="json_contenido.pregunta"></div>
                    
                        <v-btn class="btn_editar mr-2" fab x-small title="Editar" @click="activateElement('pregunta')">
                            <v-icon small>fa-pencil-alt</v-icon>
                        </v-btn>

                        <v-btn class="btn_palette mr-2" fab x-small title="Editar Color de Fondo" @click="activateBackground('pregunta')">
                            <v-icon small>fas fa-palette</v-icon>
                        </v-btn>                       
                    </v-card>
                </v-col>

            </v-row>

            <v-row>                
                <v-col cols="10">
                    <p>Respuestas:</p>
                </v-col>
                <v-col cols>
                    <v-btn @click="activateElement('respuesta')"  class="primary"> Agregar Respuestas <v-icon class="ml-1">fa-plus-circle</v-icon></v-btn>
                </v-col>
            </v-row>

            <template>
                <div v-for="(item, index) of json_contenido.tareas" :key="item.id">
                    <v-card v-if="editing && variable==index" class="pt-5 pr-5 pb-5"> 
                        <v-textarea  label="Editar" title="editar"  v-model="item.respuesta" 
                            @keyup.enter="doneEdit()" @blur="doneEdit()" @keyup.esc="cancelEdit()" prepend-icon="border-color" required>
                        </v-textarea>
                        <v-btn class="success ml-3" @click="doneEdit()">editar</v-btn>
                    </v-card>
                    <v-row>
                        <v-col cols="12" class="pl-3">
                            <v-card  v-show="! editing"  :class="['accent-5 ma-2', item.correcta ? 'success accent-5 ma-2' : 'red accent-5 ma-2' ]">
                                <v-row>
                                    <v-col cols="12" sm="10" md="10" class="pl-6">{{item.respuesta}} </v-col>
                                    <v-col cols="12" sm="2" md="2" class="text-center">  
                                        <v-btn icon @click="editarTarea(index)" title="Correcto"><v-icon>fas fa-check-circle</v-icon></v-btn>
                                        <v-btn icon @click="editarTareaOff(index)" title="Incorrecto"><v-icon>fas fa-times-circle</v-icon></v-btn>
                                        <v-btn icon @click="edit(index)" title="Editar"><v-icon>fas fa-edit</v-icon></v-btn>
                                        <v-btn icon @click="eliminar(index)" title="Eliminar"><v-icon>far fa-trash-alt</v-icon></v-btn>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
            </template><br>
        </div>

        <template>
            <v-row>
                <v-col cols="9"> 
                    <v-radio-group v-model="json_contenido.dificultad" :mandatory="false">
                        <v-row>
                            <v-col cols="3"  v-for="item of dificultades" :key="item.id">
                                <v-radio :label="item.label"  :color="item.color"  :value="item.value"></v-radio>
                            </v-col>
                        </v-row>
                    </v-radio-group>

                </v-col>
                
                
                <v-col cols="3">
                    <v-row>
                        <v-col col2="2">
                            <v-text-field type="number" v-model="json_contenido.orden" label="Orden"></v-text-field>
                        </v-col>
                        <v-col cols>                    
                            <v-btn  class="btn_block_style2 mt-7 mr-2" dark  @click="saveItem()" >Guardar</v-btn>                    
                        </v-col>
                    </v-row>
                </v-col>

            </v-row>
            
        

        </template>


        <!--  PLantillas de Preguntas 
            Actualizado por el Ing Wuilmer 2020-03-09
        -->
        <component :is="compName" :estadoComp="estadoModalConfig" @close="closeComponent"
                   :parametros="parametroConfig">  
        </component>

        <span v-if="test">
            Json : <code>{{json_contenido}}</code>
            <br>
            dataSet: <code>{{dataSet}}</code>
            <br>

            Tareas: <code>{{json_contenido.tareas}}</code>
            <br>
            Parametros : <code>{{parametros}}</code>
            <br>           
         </span> 
    </div>
</template>

<script>
import axios from "@/helpers/axios";
import {mapMutations } from 'vuex';
import visorContenido from '@/views/Manager/GestionContenido/viewGC/visorGestorContenido';
import LoadTemplate from './template/templatePregunta';

export default {
    name:'contenidoPregPU',
  components: { LoadTemplate, visorContenido },
  props:{
            parametros:{
                type:Object
            },
            estadoComp:{
                type:Boolean
            },
        },
     
    data(){
        return{
            dificultades:[
                {label:"Dificultad baja",color:"info",value:0},
                {label:"Dificultad media",color:"orange",value:1},
                {label:"Dificultad alta",color:"red",value:2},
            ],

            dataSet : {},
            viewQuestion: true,
            test:false, 
            titulo:'',
            btn_guardar:true,
            variable:-1,
  
            task1: 'task',
            editing: false,
            nuevaTarea: '',


            // campos nuevos 
           
            compName:"",
            estadoModalConfig: false,
            parametroConfig : [],

            evento: '',
            gestorBackground : false,               
            gestionEditor    : false,  
            gestionRespuesta  : false,
            tipoOperacion:'',
            editorData:'',
            color_fondo:  "#B5E6FF",
            Plantillas: [],

            json_contenido:{},

            
            editorConfig: {
                height : 120,
                extraPlugins:
                    "colorbutton,font,colordialog,justify, tableresize,liststyle",
                toolbar: [
                    { name: 'styles', items: [ 'Styles', 'Format', 'Font', 'FontSize' ] },
                    { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-' ] },
                    { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
                    [ 'Undo', 'Redo' ], 
                        { name: 'document', items: [ 'Source', '-','Preview'   ] },
                    { name: 'tools', items: [ 'Maximize', 'ShowBlocks' ] },
                    '/',
                    { name: 'paragraph', items: [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock' ] },
                    { name: 'links', items: [ 'Link', 'Unlink', 'Anchor' ] },
                    { name: 'insert', items: ['Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe' ] },                        
                ],        
            },



        }
    },


    mounted() {
        this.LoadMain()
    },

    watch: {
            // cada vez que la pregunta cambie, esta función será ejecutada
            estadoComp() {
                
                if(this.estadoComp){
                    this.viewQuestion = true
                    this.LoadMain()                    
                }else{   
                    //this.parametros = {}
                    this.viewQuestion = false
                    this.LimpiarForm()                 
                }
            }
        },

    methods: {
        ...mapMutations('mensajeSis', ['setEnviarMens']),

        /******FUNCIONES DE ACTUALIZACION Y REDIRECCION */
        /******actualizar lista de diapositivas, 29/02/2020 Jose Guardia */

        updateList(id) {
            this.$emit("actualizar-items",id);
        },
        
        // ACTUALIZAR 
        updaeting(){
            this.$emit('actualizar');
        },
        //REDIRIGIR
        redirigir(){
            this.$emit('redirigir');
        },
        actualizar(id) {
            this.$emit("actualizarLista",id);
        },

  
  

        async LoadMain(){
            this.LimpiarForm()
            this.getTemplate()
            this.dataSet = this.parametros.item
            
            if(this.parametros.evento=='agregar'){            
                this.calcularOrden()
            }
            if(this.parametros.evento=='editar'){            
                // console.log(`item de ediccion ${JSON.stringify(this.parametros.item.json_contenido)}`)
                this.editItem(this.parametros.item) 
            }
            
            
        },

        async editItem (item) {

            // console.log(item)

            // JSON.parse(this.prueba[0].json_contenido)
            // let objectNew = JSON.parse(item.json_contenido)
            // this.json_prueba =  typeof(objectNew);
            // this.json_prueba =  objectNew.color_fondo_titulo;  
            // this.json_contenido = JSON.parse(item.json_contenido)            
            //let tareas = JSON.parse(item.tareas)
           
            this.json_contenido = item
            this.json_contenido.orden = item.orden_contenido
            // this.json_contenido.tareas = tareas
            this.json_contenido.id_usuario = sessionStorage.id
            if(!item.json_contenido.plantilla){
                this.json_contenido.plantilla = -1
            }


        },


        async calcularOrden(){

            if(this.parametros.evento=='agregar'){
                                
                try{                    
                    let resp   = await axios.get(`/manager/contenido/contenidoCount/${this.dataSet.id_clase}`)   
                    this.json_contenido.orden = resp.data +1;
                }catch(error){
                    console.log(error)
                    this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                }        

            }else{
                this.orden = this.dataSet.orden;
            }

        },


        Templates(){
                    
            this.compName             = "LoadTemplate"
            this.estadoModalConfig    = true
            this.parametroConfig      = []
        
        },

         async getTemplate(){
            
            try{
                let response   = await axios.post(`/manager/contenido/getTemplate/`,{filtro:{estado_template:1, tipo:2}})
                let objectNew = JSON.parse(JSON.stringify(response.data))

                objectNew.unshift({
                    "id":-1,
                    "nombre_template":"Ninguno",
                })

                this.Plantillas = objectNew
                this.prueba = response.data 
            }catch(error){
                console.log(error)
                this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
            }        

        },

        closeComponent(){

            this.estadoModalConfig    = false
            this.getTemplate()
        
        },

        agregarTarea: function(){
            if(this.nuevaTarea===''){
                this.setEnviarMens({tipo:"W", mensaje:'La opción no puede estar vacia', tiempo:4000})
            }else{
                this.json_contenido.tareas.push({
                    respuesta: this.nuevaTarea,
                    correcta: false
                });
                this.nuevaTarea = '';

                 this.clearElement()
            }
        },

       //cambio de correcta del indice de la pregunta seleccionada -
       // se evita el error de no poder seleccionar la ultima - Alberto vega
       
        editarTarea: function(index){

            this.json_contenido.tareas[index].correcta = !this.json_contenido.tareas[index].correcta
                    
        },

        editarTareaOff: function(index){
            this.json_contenido.tareas[index].correcta = false
           
        },

        eliminar: function(index){
            this.json_contenido.tareas.splice(index, 1)
        },

        edit: function(index){
            this.variable = index
            this.editing = true
        },

        doneEdit: function(index){
            if(! this.task1)
            { this.json_contenido.tareas.splice(index, 1);  }
            this.editing = false
        },

        cancelEdit: function(){
            this.editing = false
            this.task1 = this.cacheBeforeEdit
        },


     
        async saveItem(){
            this.btn_guardar = false
            const respTrue  = this.json_contenido.tareas.filter(item => item.correcta == true)
            
            if(this.json_contenido.tareas.length == respTrue.length ||respTrue.length==0 ){
                this.setEnviarMens({tipo:"W", mensaje:'Debe Existir Respuesta verdadera y Falsa', tiempo:4000})
                this.btn_guardar = true
                return false
            }
            
            this.btn_guardar = false
            if(this.json_contenido.titulo === ''  || this.json_contenido.pregunta === '' || this.json_contenido.tareas.length == 0){
                this.setEnviarMens({tipo:"W", mensaje:'Existen campos vacios por favor complete', tiempo:4000})
            }else{
                this.json_contenido.id_clase = this.dataSet.id_clase;
                try{
                    let params = {contenido :this.json_contenido}
                   
                    if(this.parametros.evento == 'agregar'){                              
                        console.log(" Guardar Contenido" + params)
                        let resp = await axios.post("/manager/contenido/dp/", params);
                        console.log(resp)
                        
                        let configItem =  {miniatura:true, guardarMiniatura:true}
                        let dataSet = JSON.parse(JSON.stringify(this.dataSet))
                        const configNew = Object.assign(dataSet,configItem );
                        this.visorDiapositivas(configNew)
                        this.LoadMain()
                        this.$emit("actulizarData",this.dataSet.id_clase);    
                        this.btn_guardar = true

                        // this.LimpiarForm()               
                        // this.setEnviarMens({tipo:"S", mensaje:'SU DIAPOSITIVA HA SIDO CREADA SATISFACTORIAMENTE!!!', tiempo:4000})
                        // this.actualizar(this.dataSet.id_clase);
                        // this.btn_guardar = true 
                    }

                    if(this.parametros.evento == 'editar'){

                        let resp = await axios.put("/manager/contenido/upd/" + this.json_contenido.id_contenido,  params);
                        console.log(resp);
                        this.setEnviarMens({tipo: resp.data.messageT , mensaje: resp.data.message, tiempo:4000})
                         this.$emit("actualizar-items",this.dataSet.id_clase)

                    }
               
               
                }catch(error){
                    console.log(error);
                    this.btn_guardar = true
                }
            } 
        },


        // FUNCIONALIDADES NUEVAS

        visorDiapositivas(item){ 
                        
            this.compName             = "visorContenido"
            this.estadoModalConfig    = true
            this.parametroConfig = item
        
        },

        clearElement(){                          
            this.gestorBackground = false               
            this.gestionEditor    = false  
            this.gestionRespuesta  = false
        },
             


        activateElement(item){

            this.clearElement()
            this.tag = item
            this.evento = "agregar"

            if(item==='titulo')
            {                   
                this.gestionEditor = true
                this.tipoOperacion = 'TITULO'
                this.editorData =  this.json_contenido.titulo
                this.color_fondo = this.json_contenido.color_fondo_titulo
            }
            
            if(item==='pregunta')
            {
                this.gestionEditor = true
                this.tipoOperacion = 'PREGUNTA'
                this.editorData =  this.json_contenido.pregunta
                this.color_fondo = this.json_contenido.color_fondo_pregunta
            }
            

            if(item==='respuesta')
            {
                this.gestionRespuesta = true
                this.tipoOperacion = 'RESPUESTA'
                // this.editorData =  this.json_contenido.pregunta
                // this.color_fondo = this.json_contenido.color_fondo_pregunta
            }

           
        },


        saveText(tag){
            
            if(tag === 'titulo'){
                this.json_contenido.titulo = this.editorData
                this.gestionEditor=false
            }
        
            if(tag === 'pregunta'){
                this.json_contenido.pregunta = this.editorData
                this.gestionEditor=false
            }       
        
            if(tag === 'texto'){  
                this.addColumnaText()    
            }
        },



        // END edit text  //
        ////////////////////

        activateBackground(tag){
            this.tag = tag
            this.clearElement()
            let error = true

            if (tag == "titulo"){                    
                this.color_fondo = this.json_contenido.color_fondo_titulo
                error = false
            }

            if (tag == "pregunta"){
                this.color_fondo = this.json_contenido.color_fondo_pregunta
                error = false
            }                

            
            if(error){
                this.setEnviarMens({tipo:"S", mensaje: `Error interno en configuración fondo`, tiempo:null})
            }else{
                this.gestorBackground = true                    
            }
        },

                
        saveBackground(tag){

            if (tag == "titulo"){                    
                this.json_contenido.color_fondo_titulo = this.color_fondo                     
            }

            if (tag == "pregunta"){
                this.json_contenido.color_fondo_pregunta = this.color_fondo
            }                

        },




        eventPlantilla(id){

            if(id>0){

                let result = this.Plantillas.filter(item => item.id ==  id)
                // let js =  result[0];
                let js =  JSON.parse(result[0].json_contenido);
                //console.log(js.titulo)
                // console.log(js)
                // let x = JSON.parse(result[0])
                
                this.json_contenido.titulo                = js.titulo
                this.json_contenido.pregunta              = js.pregunta
                this.json_contenido.background            = js.background
                this.json_contenido.color_fondo_titulo    = js.color_fondo_titulo
                this.json_contenido.color_fondo_pregunta  = js.color_fondo_pregunta


            }else{
                this.LimpiarForm()
            }
        },

        LimpiarForm(){                

            this.json_contenido = {
                id_clase:null,
                id_usuario:sessionStorage.id,
                tipo:'PM',
                plantilla: -1,
                ambito:1,
                pertenece:'CT',
                dificultad:0,
                titulo:'<span style="font-size:36px">Ingrese título</span>',
                subtitulo:'',
                color_fondo_titulo: "#FFFFFF",  
                panelsw1:false,
                panelsw2:false,
                pregunta:'<span style="font-size:28px"> Ingrese pregunta</span>',
                color_fondo_pregunta: "#FFFFFF", 
                tareas: [],
                orden:null,
            }
        },    
 
    },

}
</script>
<style scoped>
</style>